var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { channelAPI } from "../API/api";
import { setSelectedChannel } from "../store/slices/appSlice";
import { createObjectChannel } from "../utils/utils";
import { useAppDispatch } from "./hook";
export const useChannelClickHandler = ({ isSelected, channel, currentUserID, setIsNotAccess, setNotFoundChannel }) => {
    const dispatch = useAppDispatch();
    const handleClickToChannel = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!isSelected) {
            const updateChannel = yield channelAPI.getCurrentInfo(channel.channelID);
            // if(!updateChannel) throw new Error('Такого канала больше нет')
            if (!updateChannel) {
                console.log('Такого канала больше нет');
                setNotFoundChannel(true);
                return;
            }
            const chanelObj = createObjectChannel(updateChannel);
            const isSubscriber = (_a = updateChannel.listOfSubscribers) === null || _a === void 0 ? void 0 : _a.some(sub => sub.uid === currentUserID);
            if (!updateChannel.isOpen && !isSubscriber) {
                setIsNotAccess(true);
                return;
            }
            delete chanelObj.channel.listOfSubscribers;
            dispatch(setSelectedChannel(chanelObj));
        }
    });
    return { handleClickToChannel };
};
